module.exports = __webpack_public_path__ + "static/media/iconClassesActive.02fd48c4.svg";